export const FETCH_ALL_ORDERS_BEGIN = "FETCH_ALL_ORDERS_BEGIN";
export const FETCH_ALL_ORDERS_SUCCESS = "FETCH_ALL_ORDERS_SUCCESS";
export const FETCH_ALL_ORDERS_FAILURE = "FETCH_ALL_ORDERS_FAILURE";

export const FETCH_SFA_DATA_SUCCESS = "FETCH_SFA_DATA_SUCCESS";
